import * as S from './styles'

export default function ToastContainer(props) {
  return <S.ToastContainer>{props.children}</S.ToastContainer>
}
